"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = ListItem;
exports.default = List;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _react2 = require("@linaria/react");
var _text = _interopRequireDefault(require("@ux/text"));
var _index = _interopRequireDefault(require("../tag/index.js"));
var _index2 = _interopRequireDefault(require("../tooltip/index.js"));
var _settings = require("../settings");
var _core = require("@linaria/core");
/** @module List */

/* VENDOR */

/* PL */

const IconContainer = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconContainer",
  class: "core-igavvjh"
});
const UlContainer = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "UlContainer",
  class: "core-uy4ia30",
  vars: {
    "uy4ia30-0": [({
      textAlign = 'initial'
    }) => textAlign],
    "uy4ia30-8": [({
      iconColor
    }) => iconColor]
  }
});
const OlContainer = /*#__PURE__*/(0, _react2.styled)("ol")({
  name: "OlContainer",
  class: "core-ouq7cmb"
});
const ListItemContainer = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "ListItemContainer",
  class: "core-lzrpui8",
  vars: {
    "lzrpui8-0": [({
      iconType
    }) => iconType === 'none' ? '-2.5rem' : 'initial'],
    "lzrpui8-1": [({
      iconType
    }) => iconType === 'bullet' ? `''` : 'none'],
    "lzrpui8-5": [({
      layout,
      iconType
    }) => layout === 'headline-list' ? `translateX(50%) ${iconType === 'bullet' && layout === 'headline-list' ? 'scale(0.35)' : 'scale(1)'}` : 'initial'],
    "lzrpui8-6": [({
      iconType
    }) => iconType === 'bullet' ? '50%' : 'initial']
  }
});
const featuresListTitle = "core-f4gd2vo";

/**
 * List Item
 *
 * @param {Object} props React props
 * @param {Array<string>} props.content List items
 * @param {string} props.iconType Ux Icon Type for items
 * @param {string} props.layout Layout Style for items
 * @param {boolean} props.useHowToMarkup Trigger HowTo Microdata Markup for items
 * @param {number} props.i Item index
 * @returns {React.ReactElement} items List Component
 * @public
 */
function ListItem({
  iconType = 'bullet',
  content,
  listType,
  layout,
  useHowToMarkup,
  i,
  tooltipItem
}) {
  if (!content) return null;
  const schemaAttributes = (0, _settings.getSchemaAttributes)();
  return /*#__PURE__*/_react.default.createElement(ListItemContainer, (0, _extends2.default)({
    iconType: iconType,
    listType: listType,
    layout: layout
  }, useHowToMarkup ? schemaAttributes.howToStep : null), useHowToMarkup && listType !== 'icons' && /*#__PURE__*/_react.default.createElement("meta", {
    itemProp: "position",
    content: i + 1
  }), listType === 'icons' && iconType !== 'none' && iconType !== 'bullet' && /*#__PURE__*/_react.default.createElement(IconContainer, {
    "data-cy": "list-icon",
    className: iconType
  }, /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
    name: iconType
  })), /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph",
    size: 1,
    "data-cy": "list-content"
  }, /*#__PURE__*/_react.default.createElement("span", useHowToMarkup ? schemaAttributes.text : null, content), tooltipItem && /*#__PURE__*/_react.default.createElement(_index2.default, tooltipItem)));
}
ListItem.propTypes = {
  content: _propTypes.default.node,
  iconType: _propTypes.default.string,
  listType: _propTypes.default.string,
  layout: _propTypes.default.string,
  useHowToMarkup: _propTypes.default.bool,
  i: _propTypes.default.number,
  tooltipItem: _propTypes.default.object
};

/**
 * List with icons
 * @memberof module:List
 *
 * @param {Object} props React props
 * @param {string} props.dataCy Data-cy attribute
 * @param {Object} props.style Container style
 * @param {Array<string>} props.items List items
 * @param {string} props.iconType Ux Icon Type for items
 * @param {string} props.iconColor Icon Color for items
 * @param {string} props.tagLabel Label text
 * @param {string} props.labelDesign Tag label design
 * @param {String} props.listType List Type
 * @param {string} props.layout UI List Layout
 * @param {string} props.textAlign List text align
 * @param {boolean} props.useHowToMarkup Trigger HowTo Microdata Markup for items
 * @param {string} props.listTitle List Title
 * @returns {React.ReactElement} items List Component
 * @public
 */
function List({
  dataCy,
  items,
  iconType,
  iconColor,
  tagLabel,
  labelDesign = 'warning',
  className,
  style,
  listType = 'icons',
  layout,
  textAlign,
  useHowToMarkup = false,
  listTitle
}) {
  if (!items) return null;
  if (listType === 'icons') {
    iconType = iconType || 'checkmark';
    iconColor = iconColor || _intents.default.ux.figure.figureColor0;
  }
  const iconTypeNormalized = (0, _patternLibraryUtils.normalizeIconName)(iconType);
  const listDataCy = dataCy || (listType === 'icons' ? 'ul-wrapper' : 'ol-wrapper');
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": listDataCy,
    className: className,
    style: style
  }, tagLabel && /*#__PURE__*/_react.default.createElement(_index.default, {
    text: tagLabel,
    design: labelDesign
  }), listTitle && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    "data-cy": "list-title",
    as: "title",
    text: listTitle,
    className: featuresListTitle
  }), listType === 'icons' ? /*#__PURE__*/_react.default.createElement(UlContainer, {
    role: "list",
    iconColor: iconColor,
    textAlign: textAlign,
    "data-layout": layout
  }, items?.map((item, i) => /*#__PURE__*/_react.default.createElement(ListItem, (0, _extends2.default)({
    key: i,
    i: i,
    iconType: iconTypeNormalized,
    listType: listType,
    layout: layout,
    useHowToMarkup: useHowToMarkup
  }, item)))) : /*#__PURE__*/_react.default.createElement(OlContainer, {
    role: "list"
  }, items?.map((item, i) => /*#__PURE__*/_react.default.createElement(ListItem, (0, _extends2.default)({
    key: i,
    i: i,
    listType: listType,
    useHowToMarkup: useHowToMarkup
  }, item)))));
}
List.propTypes = {
  className: _propTypes.default.string,
  dataCy: _propTypes.default.string,
  style: _propTypes.default.object,
  items: _propTypes.default.arrayOf(_propTypes.default.shape(ListItem.propTypes)),
  iconType: _propTypes.default.string,
  iconColor: _propTypes.default.string,
  tagLabel: _propTypes.default.string,
  labelDesign: _propTypes.default.string,
  listType: _propTypes.default.string,
  layout: _propTypes.default.string,
  textAlign: _propTypes.default.oneOf(['start', 'center', 'end']),
  useHowToMarkup: _propTypes.default.bool,
  listTitle: _propTypes.default.string
};